module.exports = __webpack_public_path__ + "img/arrow-down.654606cb.svg";